import { render, staticRenderFns } from "./PublishNowAction.vue?vue&type=template&id=34a38460"
import script from "./PublishNowAction.vue?vue&type=script&lang=js"
export * from "./PublishNowAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports